"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TableView = function TableView(_ref) {
  var widgetData = _ref.widgetData,
      configuration = _ref.configuration;

  var _configuration$value, _configuration$catego;

  var value = (configuration === null || configuration === void 0 ? void 0 : (_configuration$value = configuration.value) === null || _configuration$value === void 0 ? void 0 : _configuration$value.alias) || "";
  var category = (configuration === null || configuration === void 0 ? void 0 : (_configuration$catego = configuration.category) === null || _configuration$catego === void 0 ? void 0 : _configuration$catego.alias) || "";
  return _react["default"].createElement(_style.StyledTableBox, null, _react["default"].createElement(_style.StyledTable, null, _react["default"].createElement("thead", null, _react["default"].createElement(_style.StyledTr, null, _react["default"].createElement(_style.StyledTh, null, category), _react["default"].createElement(_style.StyledTh, null, value))), _react["default"].createElement("tbody", null, widgetData && widgetData.map(function (el, key) {
    return _react["default"].createElement(_style.StyledTr, {
      key: key
    }, _react["default"].createElement(_style.StyledTd, null, el.x), _react["default"].createElement(_style.StyledTd, {
      center: true
    }, el.y));
  }))));
};

var _default = TableView;
exports["default"] = _default;